document.addEventListener("cart:wim-updated", function (event) {
  const data = event.detail.parsedState ?? event.detail.matchingItem;

  if (data.id) {
    addToCartIcomm(data);
  }
});


function addToCartIcomm(data) {
  window._imMktOptions = {
    _setType: 'Lead',
    _setDomain: 'www.news.kaotikobcn.com',
    _itemsQuantity: data.quantity,
    _amount: (data.final_line_price / 100).toFixed(2),
    _extraInfo: `product_id: ${data.product_id}, variant_id: ${data.variant_id}`
  };

  (function () {
    var icomMkt = document.createElement('script');
    icomMkt.type = 'text/javascript';
    icomMkt.async = true;
    icomMkt.src = (
      document.location.protocol === 'https:'
        ? 'https://'
        : 'http://'
    ) + 'externalassets.icommarketing.com/icomMkt_tracking_jquery.min.js';

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(icomMkt, s);
  })();
}
document.addEventListener("DOMContentLoaded", function () {

  const footer_email = document.querySelector('.wim-footer .footer__block-subscribe input[name="contact[email]"]');
  const footer_submit_email = document.querySelector('.wim-footer .footer__block-subscribe .btn-subscribe');
  const radio_footer_policy = document.querySelector('.wim-footer .footer__block-subscribe input[name="footer__accept-policies"]');

  if (footer_email != null && footer_submit_email != null && radio_footer_policy != null) {

    footer_email.addEventListener("keydown", function (event) {

      if (event.key === "Enter") {

        event.preventDefault();
        if (radio_footer_policy.checked === true) {

          footer_submit_email.click();
        }
      }
    });
    footer_submit_email.addEventListener("click", function (event) {
      if (radio_footer_policy.checked === true) {

        footer_submit_email.click();
      }
    });
  }
});